export const getKeywordWordErrorMessage = (errorMessage: Record<string, string>): string =>
  errorMessage.IS_DUPLICATE_KEYWORD ||
  errorMessage.MASSAGE_STRING_BASE ||
  errorMessage.MASSAGE_STRING_EMPTY ||
  errorMessage.MASSAGE_MAXIMUM_LENGTH ||
  errorMessage.MASSAGE_ANY_REQUIRED ||
  ''
